/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SvgIcon } from "@mui/material";
import { common } from "./common";
import { components } from "./components";
import { fields } from "./fields";
import { files } from "./files";
import { models } from "./models";
import { questions } from "./questions";

const SVGIcons = {
    common,
    components,
    fields,
    files,
    models,
    questions
};

const getIcon = (props) => {
    const collection = props?.collection || "common"; 
    const name = props?.name;
    
    return (
        <SvgIcon
            component={SVGIcons[collection][name]}
            fontSize={"inherit"}
            color={"inherit"}
            overflow={"visible"}
        />
    );
};


export { getIcon };
